<template>
	<label>
		<span v-if="required">*</span>
		{{ label }}

		<input
			:type="type"
			:placeholder="placeholder"
			:value="value"
			@input="$emit('input', $event.target.value)"
			:required="required"
			:autocomplete="!autoComplete ? 'no-autocomplete' : true"
            :min="min"
            ref="input"
		>
	</label>
</template>

<script>
export default {
	props: {
		label: String,
		placeholder: String,
		value: [String, Number],
		required: Boolean,
		autoComplete: Boolean,
		type: {
			type: String,
			default: 'text'
		},
		min: String
	}
}
</script>

<style lang="scss" scoped>
label {
	display: block;
	width: 100%;
	margin-bottom: 2rem;
	font-size: 1rem;

	span {
		color: #F4949A;
	}

	input {
		margin-top: 1rem;
		padding: .5rem;
		border-radius: 0.15rem;
		border: 0.05rem solid #D8DEEB;
		width: 100%;

		&:focus::placeholder {
			color: transparent;
		}

		&[type=number] {
			text-align: right;
		}

        &[type=password], &[type=text] {
            padding-right: 55px;
        }
	}
}
</style>
